<template>
  <transition name="modal">
    <div class="modal-mask" v-show="show">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Relatório de Fechamento</h3>
        </div>
        <div class="modal-body" id="imp">
          <div class="row">
            <div class="col-sm-12 table-responsive">
              <template v-for="usu in apiData[0].usuarios">
                <table v-if="usu.consultas.length > 0" aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                  <thead>
                    <tr class="trHeader">
                      <td colspan="4" style="padding-bottom: 20px;">
                        <table style="width: 100%;">
                          <thead>
                            <tr>
                              <td style="text-align: left; width: 20%;">LOGO</td>
                              <td style="text-align: center; width: 60%; font-size: 15px;">
                                <strong>Relatório de Fechamento</strong><br/><small>({{ date_format(apiData[0].periodo_inicial) }} à {{ date_format(apiData[0].periodo_final) }})</small><br/>

                                {{ apiData[0].fantasia }} - Usuário: {{ usu.login }}
                                <br/>
                              </td>
                              <td style="text-align: right; width: 20%;">
                                Premium Consulta
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </td>
                    </tr>
                    <tr role="row">
                      <th style="width: 20%">Data</th>
                      <th style="width: 30%;">Tipo de Consulta</th>
                      <th style="width: 30%">Documento Consultado</th>
                      <th style="width: 20%;">Valor</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr class="even" role="row" v-for="item in usu.consultas">
                      <td>{{ date_format(item.created_at) }}</td>
                      <td>{{ item.tipo }}</td>
                      <td>{{ item.cpf_cnpj }}</td>
                      <td>R$ {{ number_format(item.valor,2,',','.') }}</td>
                    </tr>

                    <tr class="even" role="row">
                      <td colspan='3' style="text-align:right"><strong>Subtotal</strong></td>
                      <td><strong>R$ {{ subtotal(usu.consultas) }}</strong></td>
                    </tr>

                  </tbody>

                </table>
              </template>

              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                <thead>
                  <tr role="row">
                    <th colspan="3" style="text-align:center">Resumo da Fatura</th>
                  </tr>
                  <tr role="row">
                    <th style="width: 55%">Descrição</th>
                    <th style="width: 15%">Qtd.</th>
                    <th style="width: 30%;">Valor</th>
                  </tr>
                  <tr role="row">
                    <td>Mensalidade</td>
                    <td>---</td>
                    <td>{{ number_format(apiData[0].mensalidade,2,',','.') }}</td>
                  </tr>
                  <tr role="row">
                    <td>Total. Consultas Restritivas</td>
                    <td></td>
                    <td>{{ number_format(totais.restritiva,2,',','.') }}</td>
                  </tr>
                  <tr role="row">
                    <td>Total. Consultas Analíticas</td>
                    <td></td>
                    <td>{{ number_format(totais.analitica,2,',','.') }}</td>
                  </tr>
                  <tr role="row">
                    <td>Total Consultas</td>
                    <td></td>
                    <td>{{ number_format(totais.consulta,2,',','.') }}</td>
                  </tr>
                  <tr role="row">
                    <td>Valor Excedido</td>
                    <td></td>
                    <td>{{ number_format(totais.excedente,2,',','.') }}</td>
                  </tr>
                  <tr role="row">
                    <th>Total da Fatura</th>
                    <th>---</th>
                    <th>{{ number_format(totais.fatura,2,',','.') }}</th>
                  </tr>
                </thead>
                <tbody>

                </tbody>
              </table>


            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right" style="float:right">
            <button class="btn btn-default" @click="()=>{this.$emit('close')}">
              Fechar
            </button>
            <button @click="imprime" class="btn btn-primary">
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>

import axios from 'axios' // Cliente para requisição http

export default {
  components: {

  },
  props: ['show', 'filtro'],

  mounted () {
    console.log(this.$refs.imp);
  },

  data: () => ({
    apiData: {},
    totais: {
      restritiva: 0,
      analitica: 0,
      consulta: 0,
      excedente: 0,
      fatura: 0
    }
  }),

  methods: {
    imprime () {
      var printContents = document.getElementById('imp').innerHTML;
      var winPrint = window.open();
      winPrint.document.write('<html><head>');
      winPrint.document.write(`
        <style>
          @page{
            size:portrait;

          }
          .row {
            width: 100%;
          }

          img{
            -webkit-print-color-adjust: exact;
            display:visible;
          }

          table{
            page-break-after: always;
            width:100%;
            font-size: 10px;   
            border-spacing: 0;
            border-collapse: collapse;
          }
          th, td {
            text-align: left;
          }
          table th {
            font-size: 12px;
            font-weight:bold;
            background-color: #ccc !important;
            -webkit-print-color-adjust: exact; 
          }

          table>thead {
            margin-top: 50px;
          }

          table>tbody>tr>td, table>tbody>tr>th, table>tfoot>tr>td, table>tfoot>tr>th, table>thead>tr>td, table>thead>tr>th {
            padding: 4px;
            vertical-align: top;
            border: 1px solid #222;
          }

          .trHeader {
            border: none;
            margin-bottom: 20px;
            padding: 30px;

          }

          .trHeader table {
            border: none;
          }

          .trHeader td {
            border: none;
          }

          .trHeader table>thead>tr>td {
            border:none;
            padding: 0px;
            vertical-align: middle;
          }


          body {
            counter-reset: page 1;
          }


        </style>
        <html>
        <head>
          <title></title>
          `);
      winPrint.document.write('</head><body >');
      winPrint.document.write(printContents);
      winPrint.document.write('</body></html>');

      winPrint.document.close();
      winPrint.focus();
      winPrint.print();
      winPrint.close(); 
    },
    getImpressao () {
      axios.get(`${this.$store.state.serverURI}/api/financeiro/getImpressao/${this.$props.filtro.diaFechamento}/${this.$props.filtro.mesAno}/${this.$props.filtro.empresaId}`, this.$store.getters.getHeaderAuth)
      .then(response => {
        this.apiData = response.data;
        this.calculaTotais(this.apiData[0].usuarios);
      }).catch((error) => { this.$store.commit('throwException', error); });           
    },

    number_format(number, decimals, decPoint, thousandsSep) {
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
      var n = !isFinite(+number) ? 0 : +number;
      var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
      var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
      var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
      var s = '';
      var toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
      };
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join(dec);
    },

    date_format(param) {
      var data = param.split('-');

      var arr = data[2].split(' ');
      if (typeof arr[1] === 'undefined') {
        return arr[0]+'/'+data[1]+'/'+data[0];
      }
      return arr[0]+'/'+data[1]+'/'+data[0]+' '+arr[1];

    },

    subtotal(val) {
      var subtotal = 0;
      for (var i=0; i<val.length; i++) {
        subtotal += parseFloat(val[i].valor);
      }
      return this.number_format(subtotal, 2, ',', '.');
    },

    calculaTotais(usuarios) {
      var mensalidade = this.apiData[0].mensalidade;
      var totalRestritiva = 0;
      var totalAnalitica = 0;
      var totalConsulta = 0;
      var totalExcedente = 0;
      var totalFatura = 0;
      
      for (var i=0; i<usuarios.length; i++) {
        for (var j=0; j<usuarios[i].consultas.length; j++) {
          if (usuarios[i].consultas[j].tipo == 'RESTRITIVA') {
            totalRestritiva += parseFloat(usuarios[i].consultas[j].valor);
          }
          if (usuarios[i].consultas[j].tipo == 'ANALÍTICA') {
            totalAnalitica += parseFloat(usuarios[i].consultas[j].valor);
          }
        }
      }

      totalConsulta = totalRestritiva + totalAnalitica;
      totalFatura = mensalidade;

      if (mensalidade < totalConsulta) {
        totalExcedente = totalConsulta - mensalidade;
        totalFatura = mensalidade + totalExcedente;
      } 

      this.totais.restritiva = totalRestritiva;
      this.totais.analitica = totalAnalitica;
      this.totais.consulta = totalConsulta;
      this.totais.excedente = totalExcedente;
      this.totais.fatura = totalFatura;
    }
  },
  watch: {
    show: function (value) {
      if (value) {
        this.getImpressao();
      }
    }
  }
}

</script>

<style scoped>
  * {
    box-sizing: border-box;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
  }

  .modal-container {
    width: 70%;
    margin: 40px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #333;
  }

  .modal-body {
    margin: 10px 0;
  }

  .text-right {
    text-align: right;
  }

  .form-label {
    display: block;
    margin-bottom: 1em;
  }

  .form-label > .form-control {
    margin-top: 0.5em;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
  }

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal {
  display: block !important; /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important;
}
.modal-body {
  height: 400px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// Impressao.vue?73df2cd7